import { useState } from 'preact/hooks';
import { LegalShell } from './_LegalPage';
import { Button } from '../components/Button';
import { api } from '../lib/api';
import { clearSession, getCurrentUser } from '../lib/auth';

export function DeleteAccount() {
  const user = getCurrentUser();
  const [confirming, setConfirming] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onDelete() {
    setError(null);
    try {
      await api('/api/me', { method: 'DELETE' });
      clearSession();
      setDone(true);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Delete failed');
    }
  }

  return (
    <LegalShell
      title="Delete your account"
      updated="May 13, 2026"
      description="Delete your shotmeal account and all its data, from the app or on the web."
    >
      <p>
        This permanently removes your shotmeal account, every backup we hold,
        and every login session. Your local diary on the phone is untouched —
        the app keeps working offline.
      </p>

      {!user && (
        <div
          style={{
            marginTop: 16,
            background: 'var(--surface-2)',
            borderRadius: 14,
            padding: 16,
            color: 'var(--ink-2)',
          }}
        >
          You need to be signed in to delete your account.{' '}
          <a href="/auth" style={{ color: 'var(--ember)', fontWeight: 600 }}>
            Sign in →
          </a>
        </div>
      )}

      {user && !done && (
        <>
          <div style={{ marginTop: 16, color: 'var(--ink-2)' }}>
            Signed in as <strong style={{ color: 'var(--ink)' }}>{user.email}</strong>.
          </div>
          {!confirming ? (
            <div style={{ marginTop: 16 }}>
              <Button variant="secondary" onClick={() => setConfirming(true)}>
                Continue
              </Button>
            </div>
          ) : (
            <div style={{ marginTop: 16, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <Button onClick={onDelete} variant="ember">
                Delete my account
              </Button>
              <Button variant="ghost" onClick={() => setConfirming(false)}>
                Cancel
              </Button>
            </div>
          )}
          {error && (
            <div style={{ marginTop: 12, color: 'var(--wine)', fontSize: 13 }}>
              {error}
            </div>
          )}
        </>
      )}

      {done && (
        <div
          style={{
            marginTop: 16,
            background: 'var(--ember-tint)',
            borderRadius: 14,
            padding: 16,
            color: 'var(--ink)',
          }}
        >
          Account deleted. You can close this tab.
        </div>
      )}
    </LegalShell>
  );
}
